import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    FluidImage,
} from '@vp/swan';
import BusinessNameInput from './BusinessNameInput';

const HeroBanner = () => {
    const { t } = useTranslation();

    return (
        <Banner
            variant="full-width-image"
            textBoxHorizontalAlign="left"
            backgroundColor="transparent"
            paddingY={{ sm: '10', md: '11' }}
            as="section"
            id="banner"
        >
            <BannerTextContainer>
                <BannerText>
                    <BannerEyebrow fontSkin="body-standard-bold">
                        {t('Logomaker GenAi Landing Page > Hero > Eyebrow.value')}
                    </BannerEyebrow>
                    <BannerTitle as="h1" style={{ textWrap: 'balance' }}>
                        {t('Logomaker GenAi Landing Page > Hero > Title.value')}
                    </BannerTitle>
                    <BannerDescription as="p">
                        {t('Logomaker GenAi Landing Page > Hero > Description.value')}
                    </BannerDescription>
                    <BannerLinks>
                        <BusinessNameInput />
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <BannerImageContainer>
                <BannerImage>
                    <FluidImage
                        src={t('Logomaker GenAi Landing Page > Hero > Image.src')}
                        alt={t('Logomaker GenAi Landing Page > Hero > Image.altText')}
                    />
                </BannerImage>
            </BannerImageContainer>
        </Banner>
    );
};

export default HeroBanner;
